import { render } from "./EmployeePendingRequests.vue?vue&type=template&id=0d3e19e2"
import script from "./EmployeePendingRequests.vue?vue&type=script&lang=js"
export * from "./EmployeePendingRequests.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__